import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { toJS } from 'mobx'
import { Modal, Descriptions, Row, Col, Spin } from 'antd'
import { ExclamationCircleFilled } from '@ant-design/icons'
import { Pie } from '@ant-design/charts'
import { withTranslation } from 'react-i18next'

@inject('emailListStore')
@observer
class FormModal extends Component {
  state = {
  }
  componentDidMount() {
  }
  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }

  render() {
    const { emailListStore, addModalVisible, handleCancel, record } = this.props
    const { isFetchingSendTotal, isFetchingFailedStatistics, failedStatistics, sendTotalObj, concaterList } = emailListStore
    const sumCounts = (arr) =>
      arr.reduce((total, obj) => total + (obj.count || 0), 0);
    const sendConfig = {
      data: [
        { type: '成功', value: sendTotalObj?.successSum },
        { type: '失败', value: sendTotalObj?.failedSum }
      ],
      angleField: 'value',  // 扇形角度对应的字段
      colorField: 'type',   // 颜色映射字段
      radius: 0.8,         // 饼图半径 (0~1)
      label: {
        type: 'outer',     // 标签显示在扇形内部
        offset: '20%',    // 标签位置偏移
        content: '{name}：{percentage}', // 自定义标签内容
        // style: {
        //   fontSize: 14,
        //   textAlign: 'center',
        // },
        // spider: {
        //   // 调整蜘蛛布局参数以增加标签空间
        //   labelWidth: 200, // 部分版本可能支持此配置
        //   maxError: 0.1, // 调整标签位置精度
        //   legLength: 50, // 连接线长度
        // },
      },
      legend: {
        position: 'top', // 'left' | 'right' | 'top' | 'bottom'
      },
      interactions: [{ type: 'element-active' }], // 鼠标悬停交互
    };
    const config = {
      data: toJS(failedStatistics),
      angleField: 'value',  // 扇形角度对应的字段
      colorField: 'type',   // 颜色映射字段
      radius: 0.8,         // 饼图半径 (0~1)
      label: {
        type: 'outer',     // 标签显示在扇形内部
        offset: '20%',    // 标签位置偏移
        content: '{name}：{percentage}', // 自定义标签内容
      },
      interactions: [{ type: 'element-active' }], // 鼠标悬停交互
      // 配置图例位置为左侧
      legend: {
        position: 'left', // 'left' | 'right' | 'top' | 'bottom'
        // 调整图例项内部的标记与文字间距
        itemName: {
          spacing: 40, // 图例标记和文本之间的间距（默认值为 8）
          style: {
            fill: '#333', // 文本颜色
            fontSize: 12,
          },
        },
        // 调整图例项之间的整体间距（不同图例项的间隔）
        itemSpacing: 30, // 默认值为 16
        marker: {
          symbol: (x, y) => {
            // 定义参数
            const width = 20;   // 长方形总宽度
            const height = 12;   // 长方形总高度
            const radius = 4;   // 圆角半径

            // SVG 路径命令
            return [
              // 起点：左上角圆角起点
              ['M', x - width / 2, y - height / 2 + radius],
              // 绘制左上圆角（顺时针）
              ['A', radius, radius, 0, 0, 1, x - width / 2 + radius, y - height / 2],
              // 右侧水平线
              ['L', x + width / 2 - radius, y - height / 2],
              // 右上圆角
              ['A', radius, radius, 0, 0, 1, x + width / 2, y - height / 2 + radius],
              // 右侧垂直线
              ['L', x + width / 2, y + height / 2 - radius],
              // 右下圆角
              ['A', radius, radius, 0, 0, 1, x + width / 2 - radius, y + height / 2],
              // 左侧水平线
              ['L', x - width / 2 + radius, y + height / 2],
              // 左下圆角
              ['A', radius, radius, 0, 0, 1, x - width / 2, y + height / 2 - radius],
              // 闭合路径
              ['Z'],
            ];
          },
        },
      },
    };

    return (
      <>
        <Modal
          title='统计报告'
          closable={true}
          visible={addModalVisible}
          onCancel={handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          width={'60%'}
          centered
          footer={false}
        >
          <Spin spinning={isFetchingSendTotal || isFetchingFailedStatistics}>
            <div className='is-always-shadow'>
              <div className='el-card__header'>任务信息</div>
              <Descriptions column={2}>
                <Descriptions.Item label="开始时间">{record?.timeStart}</Descriptions.Item>
                <Descriptions.Item label="完成时间">{record?.timeEnd}</Descriptions.Item>
                <Descriptions.Item label="发件人">{record?.sender}</Descriptions.Item>
                <Descriptions.Item label="邮件列表">{record?.listes?.item?.map(a => {
                  const sum = concaterList?.find(b => b?.id === a?.listId)?.countReal
                  return <>{`${a?.listName} `}<span className='f_grey'>{`（所有邮箱：${sum}）`}</span><br /></>
                })}</Descriptions.Item>
                <Descriptions.Item label="发送模板">{record?.templates?.template?.map(a => { return a?.tplName })?.join(', ')}</Descriptions.Item>
              </Descriptions>
            </div>
            <div className='is-always-shadow'>
              <Row>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={8} span={8} className='sendDetails'>
                  <div className='el-card__header'>发送情况</div>
                  <p>一共发送 <span className='f_red'>{sendTotalObj?.totalSum}</span> 封</p>
                  <p>无效地址 <span>{sendTotalObj?.invalidSum}</span> 封</p>
                  <p>垃圾拒绝发送 <span>{sendTotalObj?.rubbishSum}</span> 封</p>

                  <p>因收件地址异常未投递成功 <span>{
                    (sendTotalObj?.totalSum ?? 0) - (sendTotalObj?.invalidSum ?? 0) - (sendTotalObj?.rubbishSum ?? 0) - (sendTotalObj?.total ?? 0)
                  }</span> 封</p>
                  <p>实际发送 <span>{sendTotalObj?.total}</span> 封</p>
                  <p>其中发送成功 <span className='f_red'>{sendTotalObj?.successSum}</span> 封， 发送失败 <span>{sendTotalObj?.failedSum}</span> 封</p>
                  <p>成功率： <span className='f_green'>{sendTotalObj?.successRatio}</span> </p>
                  <p>打开数量： <span>{sendTotalObj?.openTotal}</span> </p>
                  <p>打开率： <span>{sendTotalObj?.openRatio}</span> </p>
                </Col>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={16} span={16} style={{ padding: '50px 0' }}><Pie {...sendConfig} /></Col>
              </Row>
            </div>
            <div className='is-always-shadow'>
              <div className='el-card__header'>投递失败统计({sumCounts(failedStatistics)})</div>
              <Pie {...config} />
            </div>
            <div className='tips_box'>
              <div className='f_red' style={{ color: 'rgb(19, 113, 255)' }}><ExclamationCircleFilled /> 提示: 发送失败的数据会再次投递，这个数据要三个半小时开始同步，请晚点再观察。</div>
            </div>
          </Spin>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormModal)
